<template>
  <!-- Footer -->
  <footer  class="text-white py-4">
    <div class="container text-center">
      <p>&copy; AFM Billingham. All rights reserved.</p>
    </div>
  </footer>


</template>
<style>
.container {
  text-align: center;
}

.text {
  margin-top: 10px;
  font-size: 18px;
  font-weight: bold;
}

.nav-link-1 {
  color: rgb(75, 75, 75) !important;
  font-size: 1.25em !important;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  text-decoration: none;
}

.foot-item {
  border: 1px solid black;
  width: 160px;
  margin-left: 10px;
  margin-top: 10px;
  opacity: 0.5;
  transition: 0.3s;
  border-radius: 40px;
}

.foot-item:hover {
  background-color: rgb(99, 99, 99);
}

@media screen and (max-width: 1200px) {
  .foot-item {
    margin-top: 10px;
    /* Add margin to create space between links */
  }

}

@media screen and (max-width: 545px) {
  .foot-item {
    width: 200px;
  }

}


@media screen and (max-width: 500px) {
  .footNav {
    margin-left: 25%;
  }

}


@media screen and (max-width: 400px) {
  .footNav {
    margin-left: 20%;
  }

}
</style>
